import { FC } from 'react';

import { isFeatureEnabled } from '@ravago/shared/next-data-access';
import { FeatureToggle } from '@ravago/shared/page-data/models/config';
import { InvoiceForCurrencyForLegalEntity } from '@ravago/shared/page-data/models/elements';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';

import { Toggle } from '../../models/feature-permissions.model';

import { ClosedInvoices } from './closed-invoices/closed-invoices';
import { ClosedInvoiceFilters } from './closed-invoices/filters/closed-invoice-filters';
import { OpenInvoices } from './open-invoices/open-invoices';

type Props = {
   openInvoices: InvoiceForCurrencyForLegalEntity[];
   showOpenInvoices: boolean;
   featureToggles: FeatureToggle[];
};

export const InvoiceOverview: FC<Props> = ({ openInvoices, showOpenInvoices, featureToggles }) => {
   const isFilterToggleEnabled = isFeatureEnabled(featureToggles, Toggle.FILTERS);
   const canPayOnline = isFeatureEnabled(featureToggles, Toggle.ONLINE_PAYMENT);
   const canDeductCreditNotes = isFeatureEnabled(featureToggles, Toggle.DEDUCT_CREDIT_NOTED);
   if (showOpenInvoices) {
      return (
         <OpenInvoices
            openInvoices={openInvoices}
            isFilterToggleEnabled={isFilterToggleEnabled}
            canPayOnline={canPayOnline}
            canDeductCreditNotes={canDeductCreditNotes}
         />
      );
   }

   if (!isFeatureEnabled(featureToggles, Toggle.CLOSED_INVOICES)) {
      return null;
   }

   return (
      <Box direction="column">
         {isFilterToggleEnabled && <ClosedInvoiceFilters />}
         <ClosedInvoices />
      </Box>
   );
};
